import React from "react";
import Typography from "@material-ui/core/Typography/index";
import Toolbar from "@material-ui/core/Toolbar/index";
import AppBar from "@material-ui/core/AppBar/AppBar";

import {NavLink,} from "react-router-dom";
import logo from '../../assetImages/undraw_camera_mg5h.svg';


class AppBarWidget extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {appStyle} = this.props;
        return (
            <AppBar position="static" color="default" elevation={0} className={appStyle.appBar}>
                <Toolbar className={appStyle.toolbar}>
                    <nav><NavLink to="/"><img src={logo} height={70}/></NavLink></nav>
                    <Typography variant="h4" color="inherit" noWrap className={appStyle.menuToolbar}>
                        Capture N' Paste

                    </Typography>
                    <nav>
                        <NavLink to="/" className={appStyle.menuToolbarLinkInactive}
                                 activeClassName={appStyle.menuToolbarLinkActive} exact={true}>
                            Get Started
                        </NavLink>
                        <NavLink to="/explore"
                                 className={appStyle.menuToolbarLinkInactive}
                                 activeClassName={appStyle.menuToolbarLinkActive}>
                            Explore
                        </NavLink>
                        <NavLink to="/support"
                                 className={appStyle.menuToolbarLinkInactive}
                                 activeClassName={appStyle.menuToolbarLinkActive}>
                            Support
                        </NavLink>
                    </nav>
                </Toolbar>
            </AppBar>
        );
    }
}

export default AppBarWidget;